import React from "react";
import { Link } from "react-router-dom";
import { prefersReducedMotion } from "./scroll";

export const focusTicketAlerts = () => {
  const input = document.getElementById("bp-alerts-email");
  const target = document.getElementById("ticket-alerts");
  if (!target) return;
  target.scrollIntoView({ behavior: prefersReducedMotion() ? "auto" : "smooth", block: "center" });
  target.classList.add("is-highlighted");
  setTimeout(() => target.classList.remove("is-highlighted"), 1800);
  setTimeout(() => input?.focus({ preventScroll: true }), prefersReducedMotion() ? 0 : 600);
};

const WEB = "/assets/business-playwright/web";

const Poster = ({ poster }) => {
  const img = (
    <picture>
      <source
        media="(max-width: 899px)"
        type="image/webp"
        srcSet={`${WEB}/${poster.id}-poster-480.webp 480w, ${WEB}/${poster.id}-poster-800.webp 800w`}
        sizes="(max-width: 899px) min(90vw, 420px)"
      />
      <img src={poster.src} alt={poster.alt} loading="lazy" decoding="async" className="bp-poster-img" />
    </picture>
  );
  if (poster.action === "ticket-alerts") {
    return (
      <button type="button" className="bp-poster bp-poster--button" onClick={focusTicketAlerts} aria-describedby="ticket-alerts-label" data-testid={`poster-${poster.id}`}>
        {img}
      </button>
    );
  }
  if (!poster.href) return <div className="bp-poster" data-testid={`poster-${poster.id}`}>{img}</div>;
  return poster.href.startsWith("/") ? (
    <Link to={poster.href} className="bp-poster" aria-label={poster.alt.replace(" theatre poster", "")} data-testid={`poster-${poster.id}`}>{img}</Link>
  ) : (
    <a href={poster.href} className="bp-poster" data-testid={`poster-${poster.id}`}>{img}</a>
  );
};

export const PosterGallery = ({ id, heading, subheading, posters, testId, children }) => (
  <section id={id} className="bp-scene bp-gallery" aria-labelledby={`${id}-heading`} data-testid={testId}>
    <div className="bp-wrap">
      <div className="bp-gallery-head">
        <h2 id={`${id}-heading`} className="bp-gallery-heading" data-testid={`${testId}-heading`}>{heading}</h2>
        <p className="bp-gallery-sub" data-testid={`${testId}-subheading`}>{subheading}</p>
      </div>
      <ul className="bp-posters" data-testid={`${testId}-posters`}>
        {posters.map((p) => (
          <li key={p.id}><Poster poster={p} /></li>
        ))}
      </ul>
      {children}
    </div>
  </section>
);
